// import React, { useState } from 'react';
// import ReusableTabs from '../../pages/ReusableTabs';
// import PdiReviewTpi from './PdiReviewTpi/PdiReviewTpi';
// import MsplApprovals from './MsplApprovals';
// import DocumentSection from './SupportedDocuments';

// const PdiTabsComponent = () => {
//   const [activeTab, setActiveTab] = useState(0); 

//   const tabs = [
//     { label: 'PDI REVIEW-TPI', component: <PdiReviewTpi /> },
//     { label: 'MSPL Approvals', component: <MsplApprovals /> }, 
//     { label: 'Supported Documents', component: <DocumentSection /> },
//   ];

//   return (
//     <ReusableTabs
//       tabs={tabs}
//       defaultTab={0}
//       activeTab={activeTab}        
//       onTabChange={setActiveTab}   
//       panelStyles={{ padding: '16px' }}
//     />
//   );
// };

// export default PdiTabsComponent;

import React, { useState, useEffect } from 'react';
import ReusableTabs from '../../pages/ReusableTabs';
import PdiReviewTpi from './PdiReviewTpi/PdiReviewTpi';
import MsplApprovals from './MsplApprovals';
import DocumentSection from './SupportedDocuments';

const PdiTabsComponent = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [canViewPdiTpi, setCanViewPdiTpi] = useState(false); // ← Only new state
  const [canViewSupportedDocs, setCanViewSupportedDocs] = useState(false);

  // ← Check PDI_Review_TPI_View role from sessionStorage
  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanViewSupportedDocs(roles.includes("PDI_Supported_Documents_View"));
      setCanViewPdiTpi(roles.includes("PDI_Review_TPI_Edit"));
    }
  }, []);

  // Build tabs dynamically — only include PDI REVIEW-TPI if user has permission
  const tabs = [
    ...(canViewPdiTpi
      ? [{ label: 'PDI REVIEW-TPI', component: <PdiReviewTpi /> }]
      : []),
    { label: 'MSPL Approvals', component: <MsplApprovals /> },
    ...(canViewSupportedDocs
      ?[{ label: 'Supported Documents', component: <DocumentSection /> }]
      :[])
  ];

  // Optional: If the first tab is hidden and activeTab was 0, switch to first available tab
  React.useEffect(() => {
    if (!canViewPdiTpi && activeTab === 0 && tabs.length > 0) {
      setActiveTab(0); // It will now point to MSPL Approvals
    }
  }, [canViewPdiTpi, tabs.length, activeTab]);

  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      panelStyles={{ padding: '16px' }}
    />
  );
};

export default PdiTabsComponent;